import getInviteBodyText from "./getInviteBodyText";
import getQueryErrorDescription from "./getQueryErrorDescription";
import getQueryErrorTryAgainLater from "./getQueryErrorTryAgainLater";
import getQueryErrorInvalidFormat from "./getQueryErrorInvalidFormat";
import getQueryErrorDeauthorization from "./getQueryErrorDeauthorization";
import getQueryErrorPermissionDenied from "./getQueryErrorPermissionDenied";
import getErrorNotFoundConfigProperty from "./getErrorNotFoundConfigProperty";
import getQueryErrorInvalidLoginOrPassword from "./getQueryErrorInvalidLoginOrPassword";

export {
  getInviteBodyText,
  getQueryErrorDescription,
  getQueryErrorTryAgainLater,
  getQueryErrorInvalidFormat,
  getQueryErrorDeauthorization,
  getQueryErrorPermissionDenied,
  getErrorNotFoundConfigProperty,
  getQueryErrorInvalidLoginOrPassword,
};
